import { registerLocaleData } from '@angular/common';
import { EnvironmentProviders, provideAppInitializer } from '@angular/core';

import { LOCALE_GB } from '@shared/utils/locales';

export const localeDataInitializer: EnvironmentProviders = provideAppInitializer(() => {
  registerLocaleData(LOCALE_GB);
});
